import axios from "axios";
import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChangePasswordDialog({ open, onOpenChange, forced }) {
  const { refreshUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState({ text: "", error: false });

  const submit = async event => {
    event.preventDefault();
    if (next.length < 6) { setNotice({ text: "Yeni şifre en az 6 karakter olmalı", error: true }); return; }
    if (next !== again) { setNotice({ text: "Yeni şifreler aynı değil", error: true }); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: next });
      setNotice({ text: "Şifreniz güncellendi", error: false });
      setCurrent(""); setNext(""); setAgain("");
      await refreshUser();
      setTimeout(() => onOpenChange(false), 800);
    } catch (e) {
      setNotice({ text: e?.response?.data?.detail || "Şifre değiştirilemedi", error: true });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={o => { if (!forced) onOpenChange(o); }}>
      <DialogContent className="edit-dialog" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Şifre değiştir</DialogTitle>
          <DialogDescription>
            {forced ? "İlk girişinizde şifrenizi değiştirmeniz gerekiyor." : "Mevcut şifrenizi girip yeni şifrenizi belirleyin."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="edit-form">
          <div className="field">
            <label>Mevcut şifre</label>
            <input data-testid="current-password-input" type="password" required value={current} onChange={e => setCurrent(e.target.value)}/>
          </div>
          <div className="field">
            <label>Yeni şifre</label>
            <input data-testid="new-password-input" type="password" required value={next} onChange={e => setNext(e.target.value)}/>
          </div>
          <div className="field">
            <label>Yeni şifre (tekrar)</label>
            <input data-testid="new-password-again-input" type="password" required value={again} onChange={e => setAgain(e.target.value)}/>
          </div>
          <div className="dialog-actions">
            {!forced && <button type="button" className="outline-btn" data-testid="change-password-cancel" onClick={() => onOpenChange(false)}>Kapat</button>}
            <button type="submit" className="primary-btn" data-testid="change-password-submit" disabled={busy}>
              {busy ? <Loader2 size={16} className="spin"/> : <KeyRound size={16}/>} Kaydet
            </button>
          </div>
          {notice.text && <div className={`notice ${notice.error ? "error" : ""}`} data-testid="change-password-notice">{notice.text}</div>}
        </form>
      </DialogContent>
    </Dialog>
  );
}
